import { useAuthStore } from '~/store/auth';

import ApiBase from './base';

export default class OrderService extends ApiBase {
  async exportOrders(body: unknown) {
    const { data } = await this.client.post(`v1/export-orders`, body);

    return data;
  }

  /**
   * Carries the merchant's token explicitly because ApiBase does not: order lookup is shared with
   * Concierge and guarded by the front-door/guest-session policy, whose only other accepted credential
   * is a Concierge-stamped header Valet cannot send. Without this the call is refused once the rollout
   * flag reaches enforce.
   */
  async findByEmailAndSourceOrderId(email: string, sourceOrderId: string) {
    const { accessToken } = useAuthStore();

    const { data } = await this.client.get('v1/order-lookup/claim', {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: { email, order: sourceOrderId },
    });

    return data;
  }
}
